export default __webpack_public_path__ + "static/media/quiz.6a768afe.svg";